import { Container } from '@/components/container';
import { Demo2Content } from '.';
const Demo2Page = () => {
  return <Container>
      <Demo2Content />
    </Container>;
};
export { Demo2Page };